import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  dataListing: [],
  kpis: [],
  dataRecords: [],
  inQueue: [],
  inProgress: [],
  completed: [],
  technician: [],
  tools: [],
  countDataListing: 0,
  locations: [],
  filterBy: 1,
  filterByOptions: [
    {
      name: 'All',
      value: 1
    },
    {
      name: 'Region',
      value: 2
    },
    {
      name: 'Market',
      value: 3
    },
    {
      name: 'Location',
      value: 4
    }
  ],
  typeBy: 0,
  pageSize: storage.session.getItem(types.SESSION_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.SESSION_DAYS) || 0,
  searchTerm: storage.session.getItem(types.SESSION_SEARCH_TERM) || '',
  filter: storage.session.getItem(types.SESSION_FILTER) || 'ALL',
  startDate: storage.session.getItem(types.SESSION_START_DATE) || null,
  endDate: storage.session.getItem(types.SESSION_END_DATE) || null,
  breakdownSummary: null
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js